<template>
    <v-form ref="signupForm" lazy-validation>
        <!-- {{ user }}
        {{ readOnlyForm }} -->
        <v-row dense>
            <v-col cols="12" sm="6">
                <debounced-search v-model="user.mobileNo" label="MobileNo" :rules="mobileNoRules" :debounceTime="1000" v-bind="$props"
                    @search="findCustomerUsingMobileNumber" :outlined="!readOnlyForm" :filled="readOnlyForm" :disabled="readOnlyForm" :clearable="!readOnlyForm"></debounced-search>
                <!-- <v-text-field v-model="user.mobileNo" :rules="mobileNoRules" label="Mobile Number*" :outlined="!readOnlyForm" :filled="readOnlyForm" :readOnly="readOnlyForm"/> -->
            </v-col>
            <v-col cols="12" sm="6">
                <v-text-field v-model="user.email" :rules="emailRules" label="Email" :outlined="!readOnlyForm"
                    :filled="readOnlyForm" :disabled="readOnlyForm"  :clearable="!readOnlyForm"/>
            </v-col>
            <v-col cols="12" sm="6">
                <v-text-field v-model="user.firstName" :rules="firstNameRules" label="FirstName*"
                    :outlined="!readOnlyForm" :filled="readOnlyForm" :disabled="readOnlyForm"  :clearable="!readOnlyForm"/>
            </v-col>
            <v-col cols="12" sm="6">
                <v-text-field v-model="user.lastName" :rules="lastNameRules" label="LastName*" :outlined="!readOnlyForm"
                    :filled="readOnlyForm" :disabled="readOnlyForm"  :clearable="!readOnlyForm"/>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import _ from 'lodash';
import appConstants from '../utils/appConstants';
import DebouncedSearch from './DebouncedSearch.vue';

export default {
    components: { DebouncedSearch },
    props: {
        value: {
            type: Object,
            default: () => undefined
        }
    },
    computed: {
        user: {
            get() {
                //debugger
                //return !_.isEmpty(this.value?.mobileNo) ? this.value : this.getUserProfile() ? this.extractLoggedInUserDetails() : this.defaultUserDetails()
                return this.getUserProfile() ? this.extractLoggedInUserDetails() : this.value.mobileNo ? this.value :this.defaultUserDetails()
            },
            set(value) {
                this.$emit('input', value)
            }
        }
    },
    data() {
        return {
            readOnlyForm: false
        }
    },
    created() {
        this.debouncedSearch = _.debounce(this.findCustomerUsingMobileNumber, 300);
    },
    methods: {
        extractLoggedInUserDetails() {
            const { displayName, mobileNo, email, _id } = this.getUserProfile()
            let split = displayName.split(' ')
            let firstName = split[0]
            let lastName = split[split.length - 1]
            let user = { firstName, lastName, mobileNo, email, _id, displayName }
            this.$emit('input', user)
            this.readOnlyForm = true
            return user
        },
        defaultUserDetails() {
            return {
                lastName: "",
                firstName: "",
                mobileNo: "",
                email: ""
            }
        },
        async findCustomerUsingMobileNumber(value, done) {
            try {
                if (value) {
                    let payload = {mobileNo: value, vendorId: this.$store.getters.vendor._id}
                    let result = await this.postItem(appConstants.CUSTOMER_BY_MOBILE, payload)
                    if(!_.isEmpty(result)){
                        this.$emit('addressesFound', [...result.addresses])
                        delete result.addresses
                        this.user = result
                    }else{
                        // Do Not use defaultUser method as it sends previously cached user details
                        this.user = {firstName: "", lastName: "", mobileNo: value, email: ""}
                        this.$emit('addressesFound', [])
                    }
                }
            } catch (error) {
                console.log(error)
            } finally {
                done()
            }

        }
    },
}
</script>

<style lang="scss" scoped></style>